import { render, staticRenderFns } from "./Placeanorder.vue?vue&type=template&id=d729f82a&scoped=true&"
import script from "./Placeanorder.vue?vue&type=script&lang=js&"
export * from "./Placeanorder.vue?vue&type=script&lang=js&"
import style0 from "./Placeanorder.vue?vue&type=style&index=0&id=d729f82a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d729f82a",
  null
  
)

export default component.exports